import { getNestedPages as getNestedPages$1 } from '@pm2/api';

function getNestedPages(configStore, sitemapStore, pageDescriptor) {
  if (pageDescriptor.children) {
    return pageDescriptor.children;
  }
  if (!pageDescriptor.hasChildren) {
    return [];
  }
  return fetchNestedPages(configStore, sitemapStore, pageDescriptor);
}
async function fetchNestedPages(configStore, sitemapStore, pageDescriptor) {
  const configState = configStore.getState();
  const children = await getNestedPages$1(
    configState.config,
    pageDescriptor.id,
    {
      levels: pageDescriptor.type === "Course" ? 2 : 1,
      previewMode: configState.previewMode
    }
  );
  sitemapStore.dispatch(
    sitemapStore.actions.updatePageDescriptor({
      ...pageDescriptor,
      children
    })
  );
  return children;
}

export { fetchNestedPages, getNestedPages };
//# sourceMappingURL=util.get-nested-pages.js.map
